<script setup lang="ts">
import type { UiDotGroupList, UiDotVariant } from '@mop/ui2/types';

defineOptions({
  name: 'Ui2PaginationDots',
});

defineProps({
  variant: {
    type: String as PropType<UiDotVariant>,
    default: 'dark',
  },
  list: {
    type: Array as PropType<UiDotGroupList>,
    default: () => [],
  },
});
</script>

<template>
  <div class="ui-pagination-dots">
    <div
      v-for="(item, index) in list"
      :key="index"
      :class="['ui-pagination-dot', `ui-pagination-dot--variant-${variant}`, `ui-pagination-dot--type-${item.type}`]"
      :style="[{ '--color': variant === 'dark' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)' }]"
    >
      <div class="ui-pagination-dot__indicator" />
    </div>
  </div>
</template>

<style lang="scss">
.ui-pagination-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1px;
}

.ui-pagination-dot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10px;
  height: 10px;
  transition: all $animation-duration-medium $animation-type-standard;
}

.ui-pagination-dot__indicator {
  border-radius: $border-radius-rounded-full;
  width: 4px;
  height: 4px;
  box-shadow: $shadow-lg;
  background-color: currentColor;

  transition: all $animation-duration-medium $animation-type-standard;
}

@each $index, $value in (0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10) {
  [data-current-thumbnail-index='#{$index}'] .ui-pagination-dot {
    &:nth-of-type(#{$index + 1}) {
      color: var(--color);
    }

    &:nth-of-type(#{$index - 1}),
    &:nth-of-type(#{$index}),
    &:nth-of-type(#{$index + 1}),
    &:nth-of-type(#{$index + 2}),
    &:nth-of-type(#{$index + 3}) {
      .ui-pagination-dot__indicator {
        width: 6px;
        height: 6px;
      }
    }

    &:nth-of-type(#{$index - 2}),
    &:nth-of-type(#{$index + 4}) {
      .ui-pagination-dot__indicator {
        width: 5px;
        height: 5px;
      }
    }
  }
}

.ui-pagination-dot--variant-dark {
  // Todo - use proper color
  color: $color-core-alpha-deep-lighter;
}

.ui-pagination-dot--variant-light {
  color: $color-surface-component-pagination-dot-indicator;
}

.ui-pagination-dot--type-video {
  transform: scale(1.2);

  .ui-pagination-dot__indicator {
    // Form a triangle for video indicator
    clip-path: polygon(30% 0%, 100% 50%, 30% 100%);
  }
}
</style>
